export const TEST_IDS = {
  STANLEY_QUERY_EDIT_PROMPT: 'stanley-query-edit-prompt',
};
